import type { CapturedEvent, KillswitchFlagsByFeature } from 'src/interfaces/usBankKillswitch'
import type { State } from '../reducers/types'

/** Stored references only — derive killswitch state in the component under `useMemo`. */
export const getKillswitchFlags = (state: State): KillswitchFlagsByFeature => {
  return state.usBankKillswitch.flags
}

export const getKillswitchFlagsLoaded = (state: State): boolean => {
  return state.usBankKillswitch.flagsLoaded
}

export const getKillswitchFlagsLoading = (state: State): boolean => {
  return state.usBankKillswitch.flagsLoading
}

export const getKillswitchFlagsError = (state: State): string | null => {
  return state.usBankKillswitch.flagsError
}

export const getKillswitchToggling = (state: State): boolean => {
  return state.usBankKillswitch.toggling
}

export const getCapturedEvents = (state: State): CapturedEvent[] => {
  return state.usBankKillswitch.capturedEvents
}

export const getCapturedEventsLoading = (state: State): boolean => {
  return state.usBankKillswitch.capturedEventsLoading
}

export const getCapturedEventsError = (state: State): string | null => {
  return state.usBankKillswitch.capturedEventsError
}

export const getCapturedEventReplaying = (state: State): boolean => {
  return state.usBankKillswitch.replaying
}
